// eslint-disable-next-line no-shadow
export enum Program {
  LanguageArt = '1',
  eScience = '2',
  Levelset = '10',
}
export default Program;
